import React from "react";

const LoadingContext = React.createContext({
  loading: "",
  setLoading: () => {}
});

export default LoadingContext;